import apiService from './api';
import { Product, CreateProductData, UpdateProductData } from '../types/productTypes';

class ProductService {
  async getProducts(): Promise<Product[]> {
    const response = await apiService.get<Product[]>('/products');
    return response.data;
  }

  async createProduct(data: CreateProductData): Promise<Product> {
    const response = await apiService.post<Product>('/products', data);
    return response.data;
  }

  async updateProduct(data: UpdateProductData): Promise<Product> {
    const { id, ...updateData } = data;
    const response = await apiService.put<Product>(`/products/${id}`, updateData);
    return response.data;
  }

  async deleteProduct(id: string): Promise<void> {
    await apiService.delete(`/products/${id}`);
  }

  async toggleProductStatus(id: string): Promise<Product> {
    const response = await apiService.patch<Product>(`/products/${id}/toggle-status`);
    return response.data;
  }
}

export const productService = new ProductService();
export default productService;